<div>
	<button
		mat-button
		class="p-0 relative lg:min-w-[50px] min-w-[30px]"
		[matMenuTriggerFor]="menu"
		(click)="hasNew = false"
	>
		<img
			class="m-0 inline-block md:w-[23px] w-[19px]"
			src="./assets/images/notification.svg"
			alt=""
		/>
		<span
			class="absolute bg-red-900 w-2.5 h-2.5 rounded-full top-[13px] lg:right-[25px] right-[15px]"
			*ngIf="hasNew"
		></span>
	</button>
	<div class="">
		<mat-menu
			class="overflow-hidden h-[83vh] max-w-[428px] mt-7 bg-input-background notification_dropdown rounded-12px"
			#menu="matMenu"
			xPosition="before"
		>
			<div class="bg-off-white pt-12px pr-[25px]">
				<img
					class="ml-auto cursor-pointer"
					src="./assets/images/close-square.svg"
					alt=""
				/>
			</div>
			<div class="bg-off-white">
				<p
					(click)="$event.stopPropagation()"
					class="text-font-16 ltr:font-DIN-bold font-bold rtl:font-semibold text-dark-grey ml-24px rtl:mr-24px"
				>
					{{ 'NOTIFICATIONS.NOTIFICATIONS' | translate }}
				</p>
				<div class="px-[10px]">
					<app-tabs
						[taps]="notificationEnum"
						[padding]="20"
						[activeTap]="NotificationFilter.NotificationTap"
						(tapChanged)="
							NotificationFilter.Paging.PageNumber = 1;
							NotificationFilter.NotificationTap = $event;
							getNotifications()
						"
					></app-tabs>
				</div>
			</div>
			<div
				infiniteScroll
				[infiniteScrollDistance]="2"
				[infiniteScrollThrottle]="500"
				[scrollWindow]="false"
				(scrolled)="onScrollDown($event)"
				*ngFor="let notification of notifications"
				id="scrollable-content"
				class="h-[80vh] overflow-y-auto"
			>
				<div *ngFor="let notification of notifications" class="mb-[12px]">
					<app-notification-card
						[isDropDown]="true"
						[notification]="notification"
					></app-notification-card>
				</div>
			</div>

			<app-no-data-found
				*ngIf="!notifications?.length"
				text="NOTIFICATIONS.NO_NOTIFICATIONS_FOUND"
			></app-no-data-found>
			<button
				routerLink="notifications"
				class="sticky bottom-0 text-font-14 text-link w-full rounded-6px border-t-[1px] border-secondry-color-Gray py-[10px] bg-off-white"
			>
				{{ 'ACTIONS.SEE_ALL' | translate }}
			</button>
		</mat-menu>
	</div>
</div>
